import groq from "groq"

export const visitReportOccasionProjection = () => groq`
  "id": _id,
  "rev": _rev,
  name,
  label,
`
